import {FC} from 'react';
import {useSetRecoilState} from 'recoil';

import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import {IconButton} from '@mui/material';
import CachedIcon from '@mui/icons-material/Cached';
import CircularProgress from '@mui/material/CircularProgress';

import {importOfDevicesQueryTrigger} from '../../../store/service-request-imports/atoms';

interface IHeadCell {
  disablePadding: boolean;
  id: string;
  label: string;
}

const headCells: IHeadCell[] = [
  {
    disablePadding: false,
    id: 'id',
    label: '№',
  },
  {
    disablePadding: false,
    id: 'fileName',
    label: 'Наименование',
  },
  {
    disablePadding: false,
    id: 'importStartDate',
    label: 'Дата начала',
  },
  {
    disablePadding: false,
    id: 'importFinishDate',
    label: 'Дата окончания',
  },
  {
    disablePadding: false,
    id: 'initiator',
    label: 'ФИО',
  },
  {
    disablePadding: false,
    id: 'statusCode',
    label: 'Статус',
  },
];

interface ITableHeadContainer {
  state: 'hasValue' | 'hasError' | 'loading';
}

export const TableHeadContainer: FC<ITableHeadContainer> = ({state}) => {
  const triggerImportOfDevicesQuery = useSetRecoilState(importOfDevicesQueryTrigger);

  return (
    <TableHead>
      <TableRow>
        <TableCell sx={{width: '34px'}} />
        {headCells.map((headCell, index) =>
          index === headCells.length - 1 ? (
            <TableCell key={headCell.id} align="center" padding={headCell.disablePadding ? 'none' : 'normal'}>
              {headCell.label}
              {state === 'loading' ? (
                <IconButton disabled>
                  <CircularProgress
                    sx={{
                      animation: 'none',
                      width: '24px !important',
                      height: '24px !important',
                      ml: 1,
                      '& svg': {width: '24px', height: '24px'},
                    }}
                    color="primary"
                  />
                </IconButton>
              ) : (
                <IconButton sx={{ml: 1}} onClick={() => triggerImportOfDevicesQuery((v) => v + 1)}>
                  <CachedIcon color="success" />
                </IconButton>
              )}
            </TableCell>
          ) : (
            <TableCell key={headCell.id} align="center" padding={headCell.disablePadding ? 'none' : 'normal'}>
              {headCell.label}
            </TableCell>
          ),
        )}
      </TableRow>
    </TableHead>
  );
};
